import { type SidePanelAppState } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import { Actions, type SetToggledActionData } from "./actions";

export const initialState: SidePanelAppState = {
  isToggled: false
};

export default (state: SidePanelAppState = initialState, action: ReduxAction<any>): SidePanelAppState => {
  switch (action.type) {
    case Actions.SetToggled:
      const { isToggled } = action.data as SetToggledActionData;
      return {
        ...state,
        isToggled
      };
    default:
      return state;
  }
};
